module.exports = __webpack_public_path__ + "static/media/Sofia-Pro-Bold.294c6b9b.ttf";